// @react
import React, { ReactElement, useRef } from 'react'
// @libraries
import { Controller, UseFormMethods, Control, useWatch } from 'react-hook-form'
import creditCardType from 'credit-card-type'
// @types
import { AutoRenewFormValues } from 'modules/common/types'
// @components
import Grid from '@bit/atd.web.grid'
import InputText from '@bit/atd.web.forms.input-text'

type PropsType = {
  formMethods: UseFormMethods<AutoRenewFormValues>
  control: Control<AutoRenewFormValues>
}

const CreditCardSecurity = ({
  formMethods,
  control,
}: PropsType): ReactElement => {
  /******************************
   *  PROPS
   *******************************/

  const { formState } = formMethods
  const { errors } = formState

  /******************************
   *  REFS
   *******************************/

  const cardSecurityCodeRef = useRef<HTMLInputElement | null>(null)

  /******************************
   *  HOOKS
   *******************************/

  const watchCardNumber = useWatch<AutoRenewFormValues>({
    control,
    name: 'cardNumber',
  })

  /******************************
   *  RENDER
   *******************************/

  let setLabel = 'CVV'
  let setPlaceholder = '000'
  let setMask = '999'
  if (watchCardNumber && creditCardType(watchCardNumber)[0]) {
    setLabel = creditCardType(watchCardNumber)[0].code.name
    setPlaceholder = `${'0'.repeat(
      creditCardType(watchCardNumber)[0].code.size,
    )}`
    setMask = `${'9'.repeat(creditCardType(watchCardNumber)[0].code.size)}`
  }

  return (
    <>
      {/* Card Security Code */}
      <Grid xs={12} sm={5} item>
        <Controller
          control={control}
          onFocus={() => cardSecurityCodeRef?.current?.focus()}
          name="cardSecurityCode"
          render={({ onChange, onBlur, value, name }) => (
            <InputText
              required
              name={name}
              label={setLabel}
              placeholder={setPlaceholder}
              mask={setMask}
              maskplaceholder={null}
              onBlur={onBlur}
              onChange={onChange}
              value={value}
              inputRef={cardSecurityCodeRef}
              error={!!errors?.cardSecurityCode}
              errorText={errors?.cardSecurityCode?.message}
            />
          )}
        />
      </Grid>
    </>
  )
}

export default CreditCardSecurity
